<template>
  <page>
    <template v-slot:header>
      <CCol xs="12" sm="4" class="offset-sm-4">
        <div class="text-center">
          <h1 class="mb-3 font-5xl">
            {{ $t(`legal.pages.privacy-policy.titlePage`) }}
          </h1>
        </div>
      </CCol>
    </template>
    <div class="mt-5 pt-3 pl-5 pr-5 mb-5">
      <div>
        <h3 class="mt-5">{{ $t(`privacyPolicy.topics.header.title`) }}</h3>
        <br />
        <p class="term-text">{{ $t(`privacyPolicy.topics.header.text1`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.header.text2`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.header.text3`) }}</p>
      </div>
      <div>
        <h3 class="mt-5">{{ $t(`privacyPolicy.topics.topic1.title`) }}</h3>
        <br />
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic1.text1`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic1.text2`) }}</p>
      </div>
      <div>
        <h3 class="mt-5">{{ $t(`privacyPolicy.topics.topic2.title`) }}</h3>
        <br />
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic2.text1`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic2.text2`) }}</p>
        <p class="term-text" v-html="$t(`privacyPolicy.topics.topic2.text3`)"></p>
        <p class="term-text" v-html="$t(`privacyPolicy.topics.topic2.text4`)"></p>
        <p class="term-text" v-html="$t(`privacyPolicy.topics.topic2.text5`)"></p>
        <p class="term-text" v-html="$t(`privacyPolicy.topics.topic2.text6`)"></p>
        <p class="term-text" v-html="$t(`privacyPolicy.topics.topic2.text7`)"></p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic2.text8`) }}</p>
      </div>
      <div>
        <h3 class="mt-5">{{ $t(`privacyPolicy.topics.topic2and1.title`) }}</h3>
        <br />
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic2and1.text`) }}</p>
      </div>
      <div>
        <h3 class="mt-5">{{ $t(`privacyPolicy.topics.topic2and2.title`) }}</h3>
        <br />
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic2and2.text1`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic2and2.text2`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic2and2.text3`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic2and2.text4`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic2and2.text5`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic2and2.text6`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic2and2.text7`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic2and2.text8`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic2and2.text9`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic2and2.text10`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic2and2.text11`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic2and2.text12`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic2and2.text13`) }}</p>
      </div>
      <div>
        <h3 class="mt-5">{{ $t(`privacyPolicy.topics.topic3.title`) }}</h3>
        <br />
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic3.text`) }}</p>
        <table class="table table-bordered" style="color: #19233f; font-size: 22px">
          <thead>
            <tr>
              <th scope="col">{{ $t(`privacyPolicy.topics.topic3.table.item1Label`) }}</th>
              <th scope="col">{{ $t(`privacyPolicy.topics.topic3.table.item2Label`) }}</th>
              <th scope="col">{{ $t(`privacyPolicy.topics.topic3.table.item3Label`) }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ $t(`privacyPolicy.topics.topic3.table.item1Text1`) }}</td>
              <td>{{ $t(`privacyPolicy.topics.topic3.table.item2Text1`) }}</td>
              <td>{{ $t(`privacyPolicy.topics.topic3.table.item3Text1`) }}</td>
            </tr>
            <tr>
              <td>{{ $t(`privacyPolicy.topics.topic3.table.item1Text2`) }}</td>
              <td>{{ $t(`privacyPolicy.topics.topic3.table.item2Text2`) }}</td>
              <td>{{ $t(`privacyPolicy.topics.topic3.table.item3Text2`) }}</td>
            </tr>
            <tr>
              <td>{{ $t(`privacyPolicy.topics.topic3.table.item1Text3`) }}</td>
              <td>{{ $t(`privacyPolicy.topics.topic3.table.item2Text3`) }}</td>
              <td>{{ $t(`privacyPolicy.topics.topic3.table.item3Text3`) }}</td>
            </tr>
            <tr>
              <td>{{ $t(`privacyPolicy.topics.topic3.table.item1Text4`) }}</td>
              <td>{{ $t(`privacyPolicy.topics.topic3.table.item2Text4`) }}</td>
              <td>{{ $t(`privacyPolicy.topics.topic3.table.item3Text4`) }}</td>
            </tr>
            <tr>
              <td>{{ $t(`privacyPolicy.topics.topic3.table.item1Text5`) }}</td>
              <td>{{ $t(`privacyPolicy.topics.topic3.table.item2Text5`) }}</td>
              <td>{{ $t(`privacyPolicy.topics.topic3.table.item3Text5`) }}</td>
            </tr>
            <tr>
              <td>{{ $t(`privacyPolicy.topics.topic3.table.item1Text6`) }}</td>
              <td>{{ $t(`privacyPolicy.topics.topic3.table.item2Text6`) }}</td>
              <td>{{ $t(`privacyPolicy.topics.topic3.table.item3Text6`) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <h3 class="mt-5">{{ $t(`privacyPolicy.topics.topic4.title`) }}</h3>
        <br />
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic4.text1`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic4.text2`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic4.text3`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic4.text4`) }}</p>
      </div>
      <div>
        <h3 class="mt-5">{{ $t(`privacyPolicy.topics.topic5.title`) }}</h3>
        <br />
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic5.text1`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic5.text2`) }}</p>
      </div>
      <div>
        <h3 class="mt-5">{{ $t(`privacyPolicy.topics.topic6.title`) }}</h3>
        <br />
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic6.text1`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic6.text2`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic6.text3`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic6.text4`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic6.text5`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic6.text6`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic6.text7`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic6.text8`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic6.text9`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic6.text10`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic6.text11`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic6.text12`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic6.text13`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic6.text14`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic6.text15`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic6.text16`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic6.text17`) }}</p>
      </div>
      <div>
        <h3 class="mt-5">{{ $t(`privacyPolicy.topics.topic7.title`) }}</h3>
        <br />
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic7.text1`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic7.text2`) }}</p>
      </div>
      <div>
        <h3 class="mt-5">{{ $t(`privacyPolicy.topics.topic8.title`) }}</h3>
        <br />
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic8.text1`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic8.text2`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic8.text3`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic8.text4`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic8.text5`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic8.text6`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic8.text7`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic8.text8`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic8.text9`) }}</p>
      </div>
      <div>
        <h3 class="mt-5">{{ $t(`privacyPolicy.topics.topic9.title`) }}</h3>
        <br />
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic9.text1`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic9.text2`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic9.text3`) }}</p>
      </div>
      <div>
        <h3 class="mt-5">{{ $t(`privacyPolicy.topics.topic10.title`) }}</h3>
        <br />
        <p class="term-text bold">{{ $t(`privacyPolicy.topics.topic10.text1`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic10.text2`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic10.text3`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic10.text4`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic10.text5`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic10.text6`) }}</p>
        <p class="term-text bold">{{ $t(`privacyPolicy.topics.topic10.text7`) }}</p>
        <p class="term-text">{{ $t(`privacyPolicy.topics.topic10.text8`) }}</p>
      </div>
    </div>
  </page>
</template>

<script>
import page from './Page.vue'

export default {
  name: 'PrivacyPolicy',
  components: {
    page,
  },

  data() {
    return {
      listItems: [],
    }
  },

  computed: {},

  mounted() {},

  methods: {},

  watch: {},
}
</script>

<style>
.text-center {
  text-align: center;
}

.term-text {
  font-size: 22px;
  line-height: 1.3em;
}
.bold {
  font-weight: bold;
}
</style>
